import React from "react";

const ApprovedProduce = () => {

    return (
        <div className="buyer-dashboard">
            <div className="text">Welcome to Amtpl Approved Produce page</div>


        </div>
    );
};

export default ApprovedProduce